import defaultImage from "@/assets/img/svg/default-image.svg";

/**
 *
 * @param {Product|BasketProduct} product
 * @param {ProductPrice|null} productPrice
 * @return {{name: string, params: {slug: string}, meta: {value: number}}}
 */
export function routeToProduct(product, productPrice = null) {
    let value = productPrice?.value || product.productPrices?.data[0]?.value;

    return {
        name: "card",
        params: {
            slug: product.slug,
        },
        meta: {
            value: value,
        },
    };
}
/**
 *
 * @param {Product|BasketProduct} product
 * @param {ProductPrice|null} productPrice
 * @return {string|null}
 */
export function resolveProductImage(product, productPrice = null) {
    return (
        productPrice?.image ||
        product?.select_type?.image ||
        product?.productPrices?.data[0]?.image ||
        product.image ||
        defaultImage
    );
}

/**
 *
 * @param {Product|BasketProduct} product
 * @param {ProductPrice|null} productPrice
 * @return {string|null}
 */
export function resolveHoverProductImage(product, productPrice = null) {
    return (
        productPrice?.image2 || product?.select_type?.image2 || product?.productPrices?.data[0]?.image2 || product.image2
    );
}

/**
 * @param {ProductPrice} productPrice
 * @return {string}
 */
export function getProductPriceTitle(productPrice) {
    return productPrice.title || productPrice.value;
}

/**
 * Backend stores some product titles in ALL CAPS Cyrillic; convert those to sentence case.
 * Latin/brand titles (e.g. "EYE MATRIX", "REGEN [Hx]") are left untouched.
 * @param {string} title
 * @return {string}
 */
export function formatProductTitle(title) {
    if (!title) return title;
    if (!/[А-ЯІЇЄҐЁ]/.test(title)) return title;
    const lower = title.toLocaleLowerCase("uk");
    return lower.charAt(0).toLocaleUpperCase("uk") + lower.slice(1);
}

/**
 * @param {PayloadProductWithCount} products
 * @return {string}
 */
export function generateProductWithCountQuery(products, additionalQuery = '') {
    const query =  products.map((product, index) => {
        return `ids[${index}][id]=${product.id}&ids[${index}][count]=${product.select_count}`;
    }).join("&");

    return `${additionalQuery}&${query}`;
}
